import type { PanderrSiteField } from "../../site-model";

function escapeHtml(value: string): string {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

export function renderSiteFieldAttribute(field?: PanderrSiteField): string {
  return field ? ` data-panderr-field="${escapeHtml(field)}"` : "";
}
